var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 24",
    fill: "#851A92",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93 5.586c.804 0 1.507.207 2.21.517.503.104.905.31 1.408.414.804.207 1.507.104 2.311-.207.503-.207 1.106-.413 1.709-.62 1.708-.414 3.316 0 4.623 1.138.402.31.704.62 1.005 1.034.1.104.1.207 0 .31-1.407.931-2.312 2.276-2.412 3.931-.201 1.656.301 3.104 1.407 4.242.503.517 1.005.93 1.709 1.241.1 0 .2 0 .1.207-.703 1.655-1.709 3.207-2.814 4.655a7.624 7.624 0 0 1-1.407 1.138c-.905.518-1.709.518-2.613.104-.402-.104-.704-.31-1.106-.414-1.206-.414-2.412-.414-3.618.103-.301.207-.603.31-.904.414-1.106.414-2.11.207-3.116-.62a6.886 6.886 0 0 1-1.407-1.552C2.01 20.172 1.206 18.724.704 17.069.302 15.931.1 14.793 0 13.552c0-1.345 0-2.69.603-3.931.804-1.966 2.211-3.31 4.221-3.931.302 0 .704-.104 1.106-.104Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.473.517c0 1.138-.403 2.07-.905 3-.704 1.035-1.508 1.655-2.613 2.07-.302.103-.704.206-1.005.206-.1 0-.201 0-.201-.207-.201-.827 0-1.655.301-2.38.704-1.447 1.81-2.482 3.317-3 .301-.103.603-.206.904-.206.201 0 .201.103.201.207v.31Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "apple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v24H0z"
  })))));
};

export default SvgApple;